import React, { useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function H5ADLargeUploader() {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [timeLeft, setTimeLeft] = useState(null);
  const [status, setStatus] = useState("");
  const [xhr, setXhr] = useState(null); // 👈 store the current request
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setProgress(0);
    setTimeLeft(null);
    setStatus("");
    setUploading(false);
  };

  const handleUpload = () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const request = new XMLHttpRequest();
    setXhr(request);
    setUploading(true);

    const startTime = Date.now();

    request.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable) {
        const percent = (e.loaded / e.total) * 100;
        const elapsed = (Date.now() - startTime) / 1000;
        const speed = e.loaded / elapsed;
        const timeRemaining = (e.total - e.loaded) / speed;

        setProgress(percent.toFixed(2));
        setTimeLeft(timeRemaining.toFixed(1));
      }
    });

    request.onload = () => {
      setUploading(false);
      if (request.status === 200) {
        setStatus("✅ Upload complete");
      } else {
        setStatus("❌ Upload failed");
        console.error("Server error:", request.status, request.responseText);
      }
    };

    request.onerror = () => {
      setUploading(false);
      setStatus("❌ Upload error");
      console.error("Network error:", request.status, request.responseText);
    };

    request.onabort = () => {
      setUploading(false);
      setStatus("⚠️ Upload cancelled");
    };

    request.open("POST", `${API_BASE}/upload-example/`);
    request.send(formData);
    setStatus("⏳ Uploading...");
  };

  const handleCancel = () => {
    if (xhr) {
      xhr.abort();
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow-md w-full max-w-xl">
      <input
        type="file"
        accept=".h5ad,.mp4"
        onChange={handleFileChange}
        className="mb-2"
      />
      <div className="flex gap-2">
        <button
          onClick={handleUpload}
          disabled={!file || uploading}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Upload
        </button>
        {uploading && (
          <button
            onClick={handleCancel}
            className="bg-red-600 text-white px-4 py-2 rounded"
          >
            Cancel
          </button>
        )}
      </div>

      {progress > 0 && (
        <div className="mt-4">
          <div className="h-4 bg-gray-300 rounded overflow-hidden">
            <div
              className="h-full bg-green-500 transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-sm mt-1">
            {progress}% uploaded — Est. {timeLeft}s left
          </p>
        </div>
      )}

      {status && <p className="mt-2">{status}</p>}
    </div>
  );
}
